module.exports = __webpack_public_path__ + "img/collapse-group.19ae862c.svg";